import * as d3 from 'd3'

export default {

  methods: {

    draw_Overall() {

      let data_ = this.rawData[0]

      let chart = this.canvasForms
      .append('g')
      .attr('transform', `translate(${this.overall.x}, ${this.overall.y})`)
      
      let plan = chart // PLAN
      .append('g')
      .attr('transform', `translate(${-80}, ${105})`)

      plan
      .append('text')
      .attr('fill', '#757575').attr('font-size', 10).text('Plan')

      plan
      .append('text')
      .attr('id', `PLAN_${this.localId}`)
      .attr('x', 0).attr('y', 15).attr('fill', '#757575').attr('font-size', 14)
      .text(data_.PLAN)

      plan
      .append('text')
      .attr('x', this.getNode(`#PLAN_${this.localId}`)).attr('y', 15)
      .attr('fill', '#757575').attr('font-size', 9).text('%')


      let actual = chart // ACTUAL
      .append('g')
      .attr('transform', `translate(${-20}, ${105})`)

      actual
      .append('text')
      .attr('fill', '#757575').attr('font-size', 10).text('Actual')

      actual
      .append('text')
      .attr('id', `ACT_${this.localId}`)
      .attr('x', 0).attr('y', 15).attr('fill', '#333').attr('font-size', 16)
      .text(data_.ACTUAL)

      actual
      .append('text')
      .attr('x', this.getNode(`#ACT_${this.localId}`)).attr('y', 15)
      .attr('fill', '#333').attr('font-size', 9).text('%')


      let delta = chart // DELTA
      .append('g')
      .attr('transform', `translate(${40}, ${105})`)

      delta
      .append('text')
      .attr('fill', '#757575').attr('font-size', 10).text('Delta')

      delta
      .append('text')
      .attr('id', `DELTA_${this.localId}`)
      .attr('x', 0).attr('y', 15)
      .attr('fill', this.gmx_deltaValue(data_.DELTA)).attr('font-size', 14)
      .text(data_.DELTA)

      delta
      .append('text')
      .attr('x', this.getNode(`#DELTA_${this.localId}`)).attr('y', 15)
      .attr('fill', this.gmx_deltaValue(data_.DELTA)).attr('font-size', 9).text('%')

      delta
      .append('path')
      .attr('transform', `translate(${this.getNode(`#DELTA_${this.localId}`) + 8}, ${4.5}) scale(${.8})`)
      .attr('d', this.gmx_deltaValue(data_.DELTA, 'icon'))
      .attr('fill', this.gmx_deltaValue(data_.DELTA))

      this.draw_Circle(chart, data_.ACTUAL) // -----> Below
    },



    draw_Circle(selection, prog) {

      let cir = this.circle
      let endAn = ''

      let bRadius = this.overall.radius - ((this.overall.thick - 2)/2)

      let arc1 = d3.arc()
      .outerRadius(bRadius)
      .innerRadius(bRadius - 1)
      .startAngle(Math.PI / 180)
      .endAngle(() => endAn || 360 * Math.PI / 180)

      let arc2 = d3.arc()
      .outerRadius(this.overall.radius)
      .innerRadius(this.overall.radius - this.overall.thick)
      .startAngle(Math.PI / 180)
      .endAngle(() => endAn || 360 * Math.PI / 180)
      .cornerRadius(this.overall.thick)

      let chart = selection
      .append('g')
      .attr('transform', `translate(${0}, ${0})`)
      .call(this.call_Link, 'Overall')

      chart
      .append('circle')
      .attr('cx', 0).attr('cy', 0).attr('r', this.overall.radius)
      .attr('fill', '#E0E0DF').attr('opacity', 0)

      chart
      .append('path')
      .attr('d', arc1).attr('fill', '#E0E0DF').attr('opacity', 1)

      chart
      .append('path')
      .attr('d', arc2)
      .attr('fill', `url(#${this.localId}_${this.overall.color}_V2)`).attr('opacity', 1)
      .transition().duration(500)
      .attrTween('d', ()=> {
        let endAngle_ = ( ((360 * (prog/100)) ) * Math.PI / 180)
        let interpolate = d3.interpolate(0 * Math.PI / 180, endAngle_)
        return function(t) {
          endAn = interpolate(t)
          return arc2()
        }
      })
    },

  } 
}